import { createContext, useEffect, useReducer } from "react";
import React from 'react';
export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload };
    case "LOGOUT":
      return { user: null };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const meData = JSON.parse(localStorage.getItem('meData'));

    // Check token expiry using meData.tokenExpiry
    if (meData && meData.tokenExpiry && Date.now() > meData.tokenExpiry) {
      // Token has expired — clear storage and logout
      localStorage.removeItem('user');
      localStorage.removeItem('meData');
      dispatch({ type: "LOGOUT" });
      window.location.href = "/";
      return;
    }

    if (user) {
      dispatch({ type: "LOGIN", payload: user });
    }

    // Schedule an auto-logout to fire exactly when the token expires
    if (meData && meData.tokenExpiry) {
      const msUntilExpiry = meData.tokenExpiry - Date.now();
      if (msUntilExpiry > 0) {
        const timer = setTimeout(() => {
          localStorage.removeItem('user');
          localStorage.removeItem('meData');
          dispatch({ type: "LOGOUT" });
          window.location.href = "/";
        }, msUntilExpiry);

        return () => clearTimeout(timer);
      }
    }

    return () => true;
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
